import script from "./CreateEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateEvent.vue?vue&type=script&setup=true&lang=js"

import "./CreateEvent.vue?vue&type=style&index=0&id=16a1d9e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16a1d9e8"]])

export default __exports__